'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _Arrow = require('./Arrow');

var _Arrow2 = _interopRequireDefault(_Arrow);

var _Content = require('./Content');

var _Content2 = _interopRequireDefault(_Content);

var _Target = require('./Target');

var _Target2 = _interopRequireDefault(_Target);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  bottom: function bottom() {
    return 'justify-content: center;';
  },
  bottomLeft: function bottomLeft() {
    return 'justify-content: flex-end;';
  },
  bottomRight: function bottomRight() {
    return 'justify-content: flex-start;';
  },
  left: function left() {
    return 'align-items: center;';
  },
  right: function right() {
    return 'align-items: center;';
  },
  top: function top() {
    return 'justify-content: center;';
  },
  topLeft: function topLeft() {
    return 'justify-content: flex-end;';
  },
  topRight: function topRight() {
    return 'justify-content: flex-start;';
  }
};

var styles = '\n  display: flex;\n  position: relative;\n';

var Popover = (0, _decisivUiUtils.buildStyledComponent)('Popover', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig
});

Popover.Arrow = _Arrow2.default;
Popover.Content = _Content2.default;
Popover.Target = _Target2.default;

exports.default = Popover;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Popover/index.js
// module id = 446
// module chunks = 2